/**
 * @generated SignedSource<<25707aff90a5701ed094842629492b94>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type genericRuleEditor_AIStagingRuleCountQuery$variables = {
  id: string;
};
export type genericRuleEditor_AIStagingRuleCountQuery$data = {
  readonly aiProductStagingRule: {
    readonly productIDs: ReadonlyArray<number>;
  } | null;
};
export type genericRuleEditor_AIStagingRuleCountQuery = {
  response: genericRuleEditor_AIStagingRuleCountQuery$data;
  variables: genericRuleEditor_AIStagingRuleCountQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productIDs",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "genericRuleEditor_AIStagingRuleCountQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "AIProductStagingRuleOutput",
        "kind": "LinkedField",
        "name": "aiProductStagingRule",
        "plural": false,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "genericRuleEditor_AIStagingRuleCountQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "AIProductStagingRuleOutput",
        "kind": "LinkedField",
        "name": "aiProductStagingRule",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "72d6b1a5e6c1d2b73ec5c120755fd90d",
    "id": null,
    "metadata": {},
    "name": "genericRuleEditor_AIStagingRuleCountQuery",
    "operationKind": "query",
    "text": "query genericRuleEditor_AIStagingRuleCountQuery(\n  $id: ID!\n) {\n  aiProductStagingRule(id: $id) {\n    productIDs\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c9d16d7fecfebd4cf0b2029dd56c74fe";

export default node;
